import { render, staticRenderFns } from "./StubButton.vue?vue&type=template&id=0bfa112a&scoped=true&"
import script from "./StubButton.vue?vue&type=script&lang=js&"
export * from "./StubButton.vue?vue&type=script&lang=js&"
import style0 from "./StubButton.vue?vue&type=style&index=0&id=0bfa112a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfa112a",
  null
  
)

export default component.exports